import {HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {AuthUtils} from 'app/core/auth/auth.utils';
import {Observable, switchMap, tap} from 'rxjs';
import {AuthenticationService} from "../../modules/auth/services/authentication.service";
import {environment} from "../../../environments/environment";

/**
 * Intercept
 *
 * @param req
 * @param next
 */

export const authInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService: AuthenticationService = inject(AuthenticationService);

    const isInternal: boolean = req.url.includes(environment.url);

    if (!isInternal) {
        return next(req);
    }

    const publicRoutes: Array<string> = [
        'auth/login',
        'auth/register',
        'auth/refresh',
        'auth/forgot-password',
        'auth/reset-password',
        'auth/verify-email',
        'auth/verify-code',
        'auth/resend-code',
    ];

    const isTokenExpired: boolean = AuthUtils.isTokenExpired(authService.accessToken);

    if (req.url.includes("auth/refresh")) {
        if (authService.refreshToken) {
            const newRefreshTokenReq = AuthUtils.addTokenToHeader(req, authService.refreshToken);
            return next(newRefreshTokenReq);
        }
    }

    if (!publicRoutes.some((route: string): boolean => req.url.includes(route))) {
        if (AuthUtils.isValidToken(authService.accessToken)) {
            if (isTokenExpired) {
                return authService.signInRefreshToken().pipe(
                    tap((user: any): void => {
                        authService.accessToken = user.token;
                        authService.refreshToken = user.refreshToken;
                    }),
                    switchMap(() => {
                        const newRequest = AuthUtils.addTokenToHeader(req, authService.accessToken);
                        return next(newRequest);
                    })
                );
            }
        }
    }

    let authReq = req.clone();

    if (
        !publicRoutes.some((route: string):  boolean => req.url.includes(route)) &&
        !isTokenExpired
    ) {
        authReq = authService.accessToken
            ? AuthUtils.addTokenToHeader(req, authService.accessToken)
            : req.clone({
                setHeaders: {},
            });
    }

    return next(authReq);
};
